'use client'
import * as React from 'react'
import { useHasActiveSubscription } from '@repo/cf-user/contexts/auth'

export function SubscriptionOnly({ children }: { children: React.ReactNode }) {
  const hasActiveSubscription = useHasActiveSubscription()

  if (!hasActiveSubscription) {
    return null
  }

  return children
}
